(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/dialog.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/dialog.js'); "use strict";


(function (svs, TweenLite) {
  'use strict';

  svs = svs || {};
  svs.components = svs.components || {};
  svs.components.dialog = svs.components.dialog || {};
  svs.components.dialog.Dialog = class Dialog extends svs.components.dialog.PubSub {
    constructor(options) {
      super();
      this.options = options;
      this.log = new svs.core.log.Logger('Dialog');
      this.isBlocking = false;
    }

    createWrapper() {
      this.el = document.createElement('div');
      this.el.className += 'js-dialog dialog';
      this.el.setAttribute('tabindex', '-1');
    }

    createQueue() {
      this.queue = new svs.components.dialog.DialogQueue({
        attachTo: this.el
      });
    }

    render() {
      this.el = document.querySelector('.js-dialog');

      if (this.el) {
        this.log.debug('No more dialog containers needed.');
      } else {
        this.createWrapper(); 

        document.body.appendChild(this.el);
      }

      this.createQueue();
      this.addEventListeners();
    }

    addEventListeners() {
      this.queue.on('changed', this, dialog => {
        this.updateClickEvents(dialog);
      });
      this.queue.on('added', this, dialog => {
        this.updateClickEvents(dialog);
      });
      this.queue.on('showDimmer', this, () => {
        this.showDimmer();

        if (!this.isBlocking) {
          this.isBlocking = true;
          this.emit('blocking', this.isBlocking);
        }
      });
      this.queue.on('hideDimmer', this, () => {
        this.hideDimmer();

        if (this.isBlocking) {
          this.isBlocking = false;
          this.emit('blocking', this.isBlocking);
        }
      });
    }

    showDimmer() {
      if (!this.isDimmed) {
        TweenLite.to(this.el, 0.2, {
          backgroundColor: 'rgba(0, 0, 0, .4)',
          onComplete: () => {
            if (this.el) {
              this.el.classList.add('dialog-dimmed');
            }
          }
        });
        this.isDimmed = true;
      }
    }

    hideDimmer() {
      const popupCount = this.queue && this.queue.areas && this.queue.areas[svs.components.dialog.area.POPUP] && this.queue.areas[svs.components.dialog.area.POPUP].count();
      const toasterCount = this.queue && this.queue.areas && this.queue.areas[svs.components.dialog.area.TOASTER] && this.queue.areas[svs.components.dialog.area.TOASTER].count();
      const contextualCount = this.queue && this.queue.areas && this.queue.areas[svs.components.dialog.area.CONTEXTUAL] && this.queue.areas[svs.components.dialog.area.CONTEXTUAL].count();

      if (this.queue && !this.queue.count()) {
        if (this.isDimmed) {
          TweenLite.to(this.el, 0.1, {
            backgroundColor: 'rgba(0,0,0,0)',
            onComplete: () => {
              if (!this.queue.count()) {
                this.remove();
              }
            }
          });
        } else {
          this.remove();
        }

        this.isDimmed = false;
      } else if (popupCount === 0 && (toasterCount > 0 || contextualCount > 0)) {
        if (this.isDimmed) {
          TweenLite.to(this.el, 0.1, {
            backgroundColor: 'rgba(0,0,0,0)',
            onComplete: () => {
              if (this.el) {
                this.el.classList.remove('dialog-dimmed');
              }
            }
          });
        }

        this.isDimmed = false;
      }
    }

    updateClickEvents(dialog) {
      if (dialog && dialog.allowDimmerClick) {
        this.addClickEvents();
      } else {
        this.removeClickEvents();
      }
    }

    addClickEvents() {
      this.el.classList.add('dialog-close-outside-click');

      this.el.onclick = e => {
        if (e.target === this.el) {
          this.queue.closeFromOutside(e);
          this.removeClickEvents();
        }
      };
    }

    remove() {
      this.removeClickEvents();

      if (this.el) {
        document.body.removeChild(this.el);
        this.el = null;
      }
    }

    removeClickEvents() {
      if (this.el) {
        this.el.classList.remove('dialog-close-outside-click');
        this.el.onclick = null;
      }
    }

    add(dialog) {
      if (!this.el) {
        this.render();
      }

      this.queue.add(dialog);
    }

    close() {
      this.queue && this.queue.closeFromOutside();
    }

  };
})(svs, TweenLite);
 })(window);